var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"submit__btn btn mb-2",class:{ 'disabled': _vm.disabled },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text ?? 'Save')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }